import { intersectionBy, orderBy } from 'lodash'

export const EUROPE_COUNTRIES = [
  'Albania',
  'Andorra',
  'Austria',
  'Belgium',
  'Belarus',
  'Bosnia and Herzegovina',
  'Bulgaria',
  'Croatia',
  'Montenegro',
  'Czech Republic',
  'Denmark',
  'Estonia',
  'Finland',
  'France',
  'Greece',
  'Spain',
  'The Netherlands',
  'Ireland',
  'Iceland',
  'Liechtenstein',
  'Lithuania',
  'Luxembourg',
  'Latvia',
  'North Macedonia',
  'Malta',
  'Moldova',
  'Monaco',
  'Germany',
  'Norway',
  'Poland',
  'Portugal',
  'Russia',
  'Romania',
  'San Marino',
  'Serbia',
  'Slovakia',
  'Slovenia',
  'Switzerland',
  'Sweden',
  'Türkiye',
  'Ukraine',
  'Vatican',
  'Hungary',
  'Great Britain',
  'Italy',
  'Azerbaijan',
  'Armenia',
  'Georgia',
  'Kosovo',
]

export const CITY_CHOICES = EUROPE_COUNTRIES.map((c) => ({
  label: c,
  value: c,
}))

export const COUNTRY_CHOICES = intersectionBy(
  orderBy(
    EUROPE_COUNTRIES.map((c) => ({
      label: c,
      value: c,
    })),
    [(country) => country.value.toLowerCase()],
    ['desc'],
  ),
  'label',
)
